// parse cookie.
// the login token is save in cookie.

function readCookie(cookieName) {
  const re = new RegExp(`[; ]${cookieName}=([^\\s;]*)`);
  const sMatch = ` ${document.cookie}`.match(re);
  if (cookieName && sMatch) return sMatch[1];
  return '';
}

export default readCookie;



// WEBPACK FOOTER //
// ./src/vuex/functions/readCookie.js